import React, { Component } from 'react';
import RequestManager from '../../requests/RequestManager';
import followingsTask from '../../requests/tasks/social/followings/followingsTask';
import followTask from '../../requests/tasks/social/follow/followTask';
import unfollowTask from '../../requests/tasks/social/unfollow/unfollowTask';
import SocialUserCard from '../../components/Social/SocialUserCard';
import Pagination from '../../components/Social/Pagination';
import Social from '../../utils/social/Social';
import Translator from "../../requests/apa/Translator";
import { showModal, MODAL_GENERIC, AAF_MODAL_ERROR } from '../../actions/modal';
import { connect } from 'react-redux';

class Socialfollowings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            followings: props.isCurrentUser ? props.ownFollowings : null,
            skip: 0,
            limit: 15,
            page: 1,
            num: 15,
        }
    }

    getData = (e, d) => {
        e.preventDefault();
        let page = d.limit / this.state.num;;

        let parameters = [{
            skip: d.skip,
            limit: d.limit,
            gameId: this.props.gameId,
        }, this.props.gamificationId ];

        let params = new followingsTask(...parameters);
        RequestManager.addRequest(params)
        .then((data) => {
            if(data.data) {
                this.setState({
                  followings: data.data,
                  skip: parameters[0].skip,
                  limit: parameters[0].limit,
                  page,
                }, () => { window.SpatialNavigation.focus('.followings .focusable') })
            }

        })
        .catch((e) => {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    content: e,
                }
            }
            this.props.showModal(modal);
        })
    }

    getTask = (p, task) => {
        const tasks = {
            follow: () => { return new followTask(p) },
            unfollow: () => { return new unfollowTask(p) }
        }

        return tasks[task]();
    }

    warningModal = () => {
        const buttons = [{
            content: Translator.get('btn_modal_ok','Aceptar'),
            props: {},
        }]

        const newModal = {
          modalType: MODAL_GENERIC,
          modalProps: {
            title: Translator.get('social_title_ups', 'Ops!'),
            content: Translator.get(
                'social_modal_anonymous',
                'Para poder seguir usuarios necesitas iniciar sesión o registrarte'
            ),
            buttons,
            buttonsAlign: 'vertical'
          }
        };

        this.props.showModal(newModal);
    }

    executeChuck = (card, task) => {
        let p = Social.buildParams(this.props.gamificationIdUserlogged, card);
        let params = this.getTask(p, task);
        const request = RequestManager.addRequest(params);

        request
            .then(data => this.success(card, task))
            .catch((e) => this.error(e));
    }

    error = (e) => {
        const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                content: e,
            }
        }

        this.props.showModal(modal);
    }

    success = (card, task) => {
        const followers = Object.assign([], this.state.followings);
        const newFollowers = Social.parseFollowers(followers, card, task);
        const dispatch = Social.getDispatch(task);

        this.props[dispatch](card.id);
        this.setState({ followers: newFollowers });

    }

    componentDidMount() {
        const params = [{
          skip: this.state.skip,
          limit: this.state.limit,
          gameId: this.props.gameId,
        }, this.props.gamificationId ] ;

        const task = new followingsTask(...params);
        RequestManager.addRequest(task).then((data) => {
          if(data.data) {
            this.setState({
              followings: data.data,
            });
          }
        })

    }

    parseFollowings = (ownfollowings, otherFollowings) => {
        const own = Object.assign([], ownfollowings)
        const other = Object.assign([], otherFollowings)

        if(Array.isArray(own) && Array.isArray(other)) {
            own.map((it) => {
                other.map((_it) => {
                    if(it.id === _it.id) {

                        if(!_it.hasOwnProperty('following')) {
                            _it.following = true;
                        }
                    }
                })
            })

            return other;
        }
    }

    follow = (event, card) => {
        const action = !Social.isAnonymous(this.props.user) ? 'executeChuck' : 'warningModal';
        this[action](card, 'follow');
    }

    unfollow = (event, card) => {
        const action = !Social.isAnonymous(this.props.user) ? 'executeChuck' : 'warningModal';
        this[action](card, 'unfollow');
    }

    render() {
        const isEmpty = !(this.state.followings) ||
          Array.isArray(this.state.followings) &&
          this.state.followings.length === 0;

        if (isEmpty) {
          const owner = this.props.isCurrentUser ? 'own' : 'other' ;
          return (
            <div className="followings-empty" style={{ fontSize: 18 }}>
              { Translator.get(`${owner}_social_profile_empty_following_msg`) }
            </div>
          )
        }

        const filterFollowings = this.parseFollowings(this.props.ownFollowings, this.state.followings);
        const followings = Object.assign([], filterFollowings);

        const followingsComponent = followings.map((it, i) => {
            const ga = Social.filterGamesArray(this.props.gameId, it.gamesArray);
            if(this.props.user.isAnonymous) { it.following = false; }
            const callToAction = it.following ? this.unfollow : this.follow;

            if(it.config.isPrivate == false && it.id !== this.props.gamificationIdUserlogged) {
                if(it.gamesArray && ga) {
                    return (<SocialUserCard
                        key={i}
                        card={it}
                        following={ it.following }
                        callToAction={callToAction}
                        gameId={this.props.gameId}
                        gamesArray={ga}
                        translations={this.props.translations}
                    />)
                }

            }
            else return null;

        })

        return(<div className="followings">
            { followingsComponent }
            <Pagination
                skip={this.state.skip}
                limit={this.state.limit}
                page={this.state.page}
                activities={followings}
                num={this.state.num}
                getData={this.getData}
                translations={this.props.translations}
            />
        </div>);
    }

}

export default connect(null, { showModal })(Socialfollowings);



// WEBPACK FOOTER //
// ./src/containers/Social/SocialFollowings.jsx